import { render, staticRenderFns } from "./trueOrFalse.vue?vue&type=template&id=39b6fd5a&scoped=true"
import script from "./trueOrFalse.vue?vue&type=script&lang=js"
export * from "./trueOrFalse.vue?vue&type=script&lang=js"
import style0 from "./trueOrFalse.vue?vue&type=style&index=0&id=39b6fd5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b6fd5a",
  null
  
)

export default component.exports